import { memo, useCallback } from 'react';

import { checkAppVersion } from '@wconcept/wconcept-common/utils/userAgentUtil';

import Actionbar from '@wconcept/wconcept-ui-renewal/components/organisms/Actionbar';
import ActionbarOld from '@wconcept/wconcept-ui-renewal/components/organisms/ActionbarOld';

interface IProps {
  active?: string;
  mode?: 'main' | 'sub' | string;
  gender?: 'Women' | 'Men' | 'All';
  btnTopShow?: boolean;
  isLogin?: boolean;
  // btnHistoryShow?: boolean;
  // btnGenderShow?: boolean;
  // isNewNativeApp?: boolean;
  // isNativeAppBoth: boolean;
  isOldNativeAppActionBar?: boolean;
  appVersion: string;
  // onClickHome?: () => void;
  // onClickMyheart?: () => void;
  // onClickMypage?: () => void;
  onClickLnb?: () => void;
  bgType?: 'white' | 'black' | undefined;
  isTopBtn?: boolean;
  isHistoryBtn?: boolean;
  isStyleClipAddBtn?: boolean;
  isShortFormBtn?: boolean | 'simple';
  isShortFormSimpleBtn?: boolean;
  isShareBtn?: boolean;
  isNativeAppBoth: boolean;
  isIPhoneXApp: boolean;
  historyImg?: string;
  historyBtnRs?: string;
  isShortFormBtnTooltip?: boolean;
  styleClipTooltipPoint?: number;
  setTooltipShown?: (value: string) => void;
  eventType?: string;
  getHistoryImg?: () => void;
  onClickTop?: () => void;
  onClickShortForm?: () => void;
  onClickHome?: () => void;
  onClickCate?: () => void;
  // onClickDiscovery?: () => void;
  onClickSearch?: () => void;
  onClickMyheart?: () => void;
  onClickMypage?: () => void;
  onClickHistory?: () => void;
  onClickStyleClipAddBtn?: () => void;
  onClickShare?: () => Promise<void>;
}

const ActionbarLayout = ({
  active,
  mode = 'main',
  gender,
  btnTopShow = false,
  isLogin,
  eventType,
  // btnHistoryShow = true,
  // btnGenderShow = true,
  // isNewNativeApp,
  // isNativeAppBoth,
  isOldNativeAppActionBar,
  appVersion,
  // onClickHome,
  // onClickMyheart,
  // onClickMypage,
  onClickLnb,
  styleClipTooltipPoint,
  bgType = 'white',
  isTopBtn = true,
  isHistoryBtn = true,
  isStyleClipAddBtn = false,
  isShortFormBtn = false,
  isShortFormSimpleBtn = false,
  isShareBtn = false,
  isNativeAppBoth,
  isIPhoneXApp,
  historyImg,
  isShortFormBtnTooltip,
  historyBtnRs,
  setTooltipShown,
  onClickTop,
  getHistoryImg,
  onClickHistory,
  onClickShortForm,
  onClickHome,
  onClickCate,
  // onClickDiscovery,
  onClickSearch,
  onClickMyheart,
  onClickMypage,
  onClickStyleClipAddBtn,
  onClickShare,
}: IProps) => {
  const getActionBarRender = useCallback(() => {
    if (isNativeAppBoth) {
      const version = appVersion;
      if (checkAppVersion(version, '7.0.0') === 'low') {
        return (
          <ActionbarOld
            wckRPImage={historyImg}
            mode={mode}
            gender={gender}
            // btnTopShow={btnTopShow}
            isNativeAppBoth={!!isNativeAppBoth}
            isOldNativeAppActionBar={isOldNativeAppActionBar}
            isIPhoneXApp={isIPhoneXApp}
            onClickTop={onClickTop}
            onClickHome={onClickHome}
            onClickMyheart={onClickMyheart}
            onClickMypage={onClickMypage}
            onClickLnb={onClickCate}
            onClickHistory={onClickHistory}
            getHistoryImg={getHistoryImg}
            isStyleClipAddBtn={isStyleClipAddBtn}
            isShortFormBtn={isShortFormBtn}
            isShortFormSimpleBtn={isShortFormSimpleBtn}
            styleClipTooltipPoint={styleClipTooltipPoint}
            isShortFormBtnTooltip={isShortFormBtnTooltip}
            onClickShortForm={onClickShortForm}
            onClickStyleClipAddBtn={onClickStyleClipAddBtn}
          />
        );
      }
    }

    return (
      <Actionbar
        active={active}
        bgType={bgType}
        isTopBtn={isTopBtn}
        isHistoryBtn={isHistoryBtn}
        isStyleClipAddBtn={isStyleClipAddBtn}
        isShortFormBtn={isShortFormBtn}
        isShortFormSimpleBtn={isShortFormSimpleBtn}
        isShareBtn={isShareBtn}
        styleClipTooltipPoint={styleClipTooltipPoint}
        isNativeAppBoth={isNativeAppBoth}
        isIPhoneXApp={isIPhoneXApp}
        historyImg={historyImg}
        isShortFormBtnTooltip={isShortFormBtnTooltip}
        setTooltipShown={setTooltipShown}
        getHistoryImg={getHistoryImg}
        onClickTop={onClickTop}
        onClickShortForm={onClickShortForm}
        onClickHome={onClickHome}
        onClickCate={onClickCate}
        onClickSearch={onClickSearch}
        onClickMyheart={onClickMyheart}
        onClickMypage={onClickMypage}
        onClickStyleClipAddBtn={onClickStyleClipAddBtn}
        onClickHistory={onClickHistory}
        onClickShare={onClickShare}
        isLogin={isLogin}
        eventType={eventType}
        appVersion={appVersion}
        historyBtnRs={historyBtnRs}
      />
    );
  }, [
    isNativeAppBoth,
    active,
    bgType,
    isTopBtn,
    isHistoryBtn,
    isStyleClipAddBtn,
    isShortFormBtn,
    isShortFormSimpleBtn,
    isShareBtn,
    styleClipTooltipPoint,
    isIPhoneXApp,
    historyImg,
    isShortFormBtnTooltip,
    setTooltipShown,
    getHistoryImg,
    onClickTop,
    onClickShortForm,
    onClickHome,
    onClickCate,
    onClickSearch,
    onClickMyheart,
    onClickMypage,
    onClickStyleClipAddBtn,
    onClickHistory,
    onClickShare,
    isLogin,
    eventType,
    appVersion,
    historyBtnRs,
    mode,
    gender,
    isOldNativeAppActionBar,
  ]);
  return <>{getActionBarRender()}</>;
};

export default memo(ActionbarLayout);
